export class ToBeCompletedFromScan {
  //? @params scanLot : minLength: 1
  scanLot: string;
  scanLotCompleted?: boolean;
  splits: {
    //? @params split minLength: 1
    split: string;
    barCode?: string;
    centreNumerisationId?: number;
    destinataireContactId?: number;
    //? @params serviceProprietaireId : maximum: 2147483647
    //? @params serviceProprietaireId :minimum: 1
    serviceProprietaireId: number;
    typeEntrantSortant?: 'All' | 'E' | 'Entrant' | 'S' | 'Sortant' | 'I' | 'Interne';
    natureId?: number;
    sourceId?: number;
    refExpediteur?: string;
    referenceRecommande?: string;
    //? @params objet : maxLength: 4000
    objet?: string;
    remarques?: string;
    dateEntree: string;
    dateDocument?: string;
    dateEcheance?: string;
    datePostale?: string;
    boiteArchive?: string;
    classementId?: number;
    fileDescription?: string;
  }[];
}
